import { render, staticRenderFns } from "./AnalyticsSection.vue?vue&type=template&id=328782fe&scoped=true&"
import script from "./AnalyticsSection.vue?vue&type=script&lang=js&"
export * from "./AnalyticsSection.vue?vue&type=script&lang=js&"
import style0 from "./AnalyticsSection.vue?vue&type=style&index=0&id=328782fe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328782fe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
